import { render } from "./CustomReports.vue?vue&type=template&id=3f218056&scoped=true"
import script from "./CustomReports.vue?vue&type=script&lang=js"
export * from "./CustomReports.vue?vue&type=script&lang=js"

import "./CustomReports.vue?vue&type=style&index=0&id=3f218056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f218056"]])

export default __exports__